export const de = {
  Authentication: {
    Profile: {
      Login: 'Anmelden',
      Logout: 'Abmelden',
    },
  },
};
